import { defaultLocale, supportedLocales } from "i18n";
import { type InitOptions } from "i18next";

export const localeStorageKeyName = "locale";
export const localeCookieName = localeStorageKeyName;
export const localeLocalStorageName = localeStorageKeyName;
export const localeSessionStorageName = localeStorageKeyName;

export const localeQueryStringName = "lng";

export const i18nextOptions = {
  fallbackLng: defaultLocale,
  supportedLngs: Array.from(supportedLocales),
  react: { useSuspense: false },
  // React already escapes text content in JSX. Letting i18next escape too
  // double-encodes interpolated values (e.g. `America/New_York` →
  // `America&#x2F;New_York`). This is the standard react-i18next setup —
  // see https://react.i18next.com/latest/i18next-instance.
  interpolation: { escapeValue: false },
} satisfies InitOptions;
